import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"

interface Sig {
  Args: {
    options: {
      fromNetworkPage: boolean
      isCreatingSchool: boolean
    }
    accept: (name: string) => {}
    decline: () => {}
  }
}

export default class AskForSchoolTitle extends Component<Sig> {
  @tracked
  nameOfNewSchool: string | null = null

  get dateInfo() {
    let today = new Date()
    let currentMonth = today.getMonth()
    let currentYear = today.getFullYear()
    let currentFallYear = 0 <= currentMonth && currentMonth < 6 ? currentYear - 1 : currentYear
    let currentSchoolYearId = "SY" + currentFallYear + (currentFallYear + 1)
    let nextSchoolYearId = "SY" + (currentFallYear + 1) + (currentFallYear + 2)
    return {
      today: today,
      currentMonth: currentMonth,
      currentYear: currentYear,
      currentFallYear: currentFallYear,
      currentSchoolYearId: currentSchoolYearId,
      nextSchoolYearId: nextSchoolYearId,
    }
  }

  get shouldShowPilotEndDate() {
    let dateInfo = this.dateInfo
    let cutoffDate = new Date(dateInfo.currentFallYear + 1, 4, 16, 0, 0, 0, 0)
    if (dateInfo.currentMonth >= 7) {
      return false
    } else {
      return dateInfo.today.getTime() < cutoffDate.getTime() ? true : false
    }
  }

  get pilotEndDate() {
    let dateInfo = this.dateInfo
    let date = new Date(dateInfo.currentFallYear + 1, 6, 30)
    return date
  }

  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      if (this.nameOfNewSchool) this.args.accept(this.nameOfNewSchool)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    AskForSchoolTitle: typeof AskForSchoolTitle
  }
}
